// 登录态区分三种不同的值
// null-不确定(仅服务端)、false-未登录、true-已登录
const reducer = (state = { isSign: null, userDetail: undefined }, action) => {
  //todo capi/personal/user/login-status/get 这个接口没正确返回 临时设置成true 方便联调
  // return { ...state, ...{ isSign: true, userDetail: action.payload } };
  switch (action.type) {
    case "UPDATE_SIGN_STATE":
      if (!action.payload) {
        return { ...state, ...{ isSign: null, userDetail: undefined } };
      } else {
        return { ...state, ...{ isSign: true, userDetail: action.payload } };
      }
    case "CLEAR_SIGN_STATE":
      return { ...state, ...{ isSign: false, userDetail: undefined } };
    default:
      return state;
  }
};

export default reducer;
